module.exports = __webpack_public_path__ + "static/media/menuimage_disruptions.1325d4bd.jpg";